<vb-auction-row
    *ngIf="summary"
    [auction]="summary"
    [lots]="carouselLots"
    [state]="state"
    [showCarousel]="showCarousel"
    [href]="cardHref"
    [showAlert]="showAlert"
    [alertActive]="alertActive"
    [alertLabel]="alertLabel"
    [showSeeAll]="showSeeAll"
    [seeAllLabel]="seeAllLabel"
    (auctionClicked)="onCardClicked()"
    (lotClicked)="onLotClicked($event)"
    (seeAllClicked)="onCardClicked()"
    (alertClicked)="onAlertClicked()">
</vb-auction-row>

<!-- Reminder dialog — same composition as the lot-list breadcrumb's. -->
<vb-dialog
    [open]="showReminderDialog"
    [eyebrow]="auction.name"
    [title]="'AuctionsPage.auctionReminders' | translate"
    (closed)="closeReminderDialog()">
    <vb-scheduler-dialog
        *ngIf="showReminderDialog"
        [auction]="auctionAsDetail"
        (remindersChange)="onRemindersChange($event)"
        (closeReminders)="closeReminderDialog()" />
    <vb-button
        dialogFooter
        variant="secondary"
        [fullWidth]="true"
        (clicked)="closeReminderDialog()">
        {{ "LotDetails.close" | translate }}
    </vb-button>
</vb-dialog>
